import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from '../../../../../../theme';

export const ReplyingContainer = styled(Box)({
    margin: '0 16px 12px 16px',
    position: 'relative'
});

export const ReplyingHeader = styled(Typography)({
    fontSize: '12px',
    color: colors.lightGrayishBlue,
    marginBottom: '8px',
    fontWeight: 500
});

export const ReplyingBubble = styled('div')({
    backgroundColor: `${colors.raisinBlack}EE`,
    borderRadius: '16px',
    padding: '12px 16px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(5px)',
    position: 'relative'
});

export const ReplyingOwner = styled(Typography)({
    color: colors.yellow80,
    fontSize: '10px',
    fontWeight: 600,
    marginBottom: '4px'
});

export const CloseButtonWrapper = styled(Box)({
    position: 'absolute',
    right: '4px',
    top: '4px',
    '& .MuiIconButton-root': {
        padding: '4px',
        color: colors.lightGrayishBlue,
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: colors.white80
        }
    }
});
